// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { ACCOUNTING_DIRECTION } from '../../constants/accountingDirection';

export default class ExternalTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingExternalTransactions';
        this.Server = this.props.context.getState().server.accountingExternalTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'note'];

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            {
                id: 'merchantTerminalId', required: true,
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                from: 'publicMerchantTerminals',
                object: 'merchantTerminal',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'systemAccountId', required: true,
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                object: 'systemAccount',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'direction', required: true,
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: ACCOUNTING_DIRECTION,
                displayGrid: true
            },
            { id: 'merchantAmount', required: true, label: 'merchantAmount', alignRight: true, cell: 'Amount', displayGrid: true },
            { id: 'systemAmount', required: true, label: 'systemAmount', alignRight: true, cell: 'Amount', displayGrid: true },
            { id: 'note', label: 'note', alignRight: false, cell: 'BigText', displayGrid: true },
            { id: 'paymentDate', label: 'paymentDate', alignRight: false, cell: 'DateTime', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
